import React, { useEffect, useState } from 'react'
import { ConnectedComponent, Provider } from 'react-redux'
import store from './redux/store'
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useHistory,
} from 'react-router-dom'
import Dashboard from './layout/Dashboard'
import { ThemeProvider } from './context/ThemeContext'
import ExternalLayout from './layout/External'
import Login from './views/Login/Login'
import NewPassword from './views/Login/NewPassword'
import { SnackBarProvider } from './context/SnackBarContext'
import { useLocalStorageState } from './hooks/useLocalStorageState'
import { userConfigJSON } from './userConfig'
import RegisterFirst from './views/Register/RegisterFirst'
import RegisterSecond from './views/Register/RegisterSecond'
import RegisterThird from './views/Register/RegisterThird'
import RegisterFourth from './views/Register/RegisterFourth'
import RegisterFifth from './views/Register/RegisterFifth'
import RegisterSixth from './views/Register/RegisterSixth'
import RegisterSeventh from './views/Register/RegisterSeventh'
import RegisterGuard from './guards/RegisterGuard'
import ErrorBoundary from './utils/ErrorBoundary'
import ForgotPassword from './views/Register/ForgotPassword'
import { TabProvider } from './context/TabContext'
import DashboardStats from './layout/DashboardStats'
import { FloatingProvider } from './context/FloatingMenuContext'
import UserChangePassword from './views/Login/UserChangePassword'
import PagoEnLinea from './views/PagoEnLinea/PagoEnLinea'
import PrivacyPolicy from './views/Policy/PrivacyPolicy'
import ConfirmedEmail from './views/Login/Confirmed-email'
import SuccessStripe from './views/Login/Success-Stripe'
import Deudor from './views/Deudor/Deudor'
import { Tab, Tabs } from '@mui/material'
import { FaPhoneAlt } from 'react-icons/fa'
import { MobileTabs } from './mobileApplication/components/tabs/tabsLayout'
import { InventoryView } from './mobileApplication/views/Inventory'
import { IndividualItemView } from './mobileApplication/views/IndividualItem'
import { StatsView } from './mobileApplication/views/Stats'
import { WarehousesView } from './mobileApplication/views/Warehouses'
import { LoadItemsView } from './mobileApplication/views/LoadItems'
import { UnloadItemsView } from './mobileApplication/views/UnloadItems'
import { ChatIAView } from './mobileApplication/views/ChatIA'
import { useLocation } from 'react-router-dom'
import { SalesView } from './mobileApplication/views/Sales'
import { CreateClientView } from './mobileApplication/views/CreateClient'
import { SaleGenerateView } from './mobileApplication/views/SaleGenerate'

//router-wrapper
const AppRoute: React.FC<AppRouteProps> = ({
  component: Component,
  layout: Layout,
  path,
  exact,
}) => (
  <Route
    path={path}
    exact={exact}
    render={(props: object) => (
      <Layout>
        <Component {...props} />
      </Layout>
    )}
  />
)

const AppRouteMobile: React.FC<AppRouteProps> = ({
  component: Component,
  layout: Layout,
  path,
  exact,
  hideTabs = false,
}) => {
  const location = useLocation()

  return (
    <Route
      path={path}
      exact={exact}
      render={(props: object) => (
        <div className={location.pathname !== '/chatIA' ? 'p-[20px]' : ''}>
          <Component {...props} />
          {!hideTabs && (
            <div className="fixed bottom-0 w-full" style={{ marginLeft: -20 }}>
              <MobileTabs />
            </div>
          )}
        </div>
      )}
    />
  )
}

const App: React.FC = () => {
  useLocalStorageState('user-config', userConfigJSON)

  const [width, setWidth] = useState(window.innerWidth)

  const history = useHistory()

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)

    window.addEventListener('resize', handleResize)

    // Clean up the event listener on unmount
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // useEffect(() => {
  //   if (width < 768) {
  //     setTimeout(() => {
  //       history.push('/inventory')
  //     }, 2000)
  //   } else {
  //     setTimeout(() => {
  //       history.push('/dashboard/dashboard/init')
  //     }, 2000)
  //   }
  // }, [width])

  // if (width < 768) {
  //   return (
  //     <Provider store={store}>
  //       <ThemeProvider>
  //         <SnackBarProvider>
  //           <TabProvider>
  //             <FloatingProvider>
  //               <div className="app">
  //                 <BrowserRouter>
  //                   <Switch>
  //                     <Route path="/" exact>
  //                       <Redirect to="/dashboard" />
  //                     </Route>
  //                     <Route path="/pago_en_linea" component={PagoEnLinea} />
  //                     <Route path="/privacy" component={PrivacyPolicy} />
  //                     <Route path="/registro" component={RegisterFirst} />
  //                     <Route
  //                       path="/registro_segundo"
  //                       component={RegisterSecond}
  //                     />

                  
  //                     <Route
  //                       exact
  //                       path="/ingresar"
  //                       // layout={ExternalLayout}
  //                       component={Login}
  //                     />

  //                     <Route exact path="/">
  //                       <Redirect to="/ingresar" />
  //                     </Route>
  //                     {/* <AppRoute path="*" layout={External} component={NotFound} */}
  //                   </Switch>
  //                 </BrowserRouter>
  //               </div>
  //             </FloatingProvider>
  //           </TabProvider>
  //         </SnackBarProvider>
  //       </ThemeProvider>
  //     </Provider>
  //   )
  // }

  return (
    <Provider store={store}>
      <ThemeProvider>
        <SnackBarProvider>
          <TabProvider>
            <FloatingProvider>
              <div className="app">
                <BrowserRouter>
                  <Switch>
                    <Route path="/" exact>
                      <Redirect to="/dashboard" />
                    </Route>
                    <Route path="/pago_en_linea" component={PagoEnLinea} />
                    <Route path="/privacy" component={PrivacyPolicy} />
                    <Route path="/registro" component={RegisterFirst} />
                    <Route
                      path="/registro_segundo"
                      component={RegisterSecond}
                    />
                    <Route path="/registro_tercero" component={RegisterThird} />
                    <Route path="/registro_cuarto" component={RegisterFourth} />
                    <Route path="/registro_quinto" component={RegisterFifth} />
                    <Route path="/registro_sexto" component={RegisterSixth} />
                    <Route
                      path="/registro_septimo"
                      component={RegisterSeventh}
                    />
                    
                    <Route path="/forgotpassword" component={ForgotPassword} />
                    <AppRoute
                      exact
                      path="/nuevaClave"
                      layout={ExternalLayout}
                      component={NewPassword}
                    />
                    <AppRoute
                      exact
                      path="/verificarCorreo"
                      layout={ExternalLayout}
                      component={UserChangePassword}
                    />

                    <Route exact path="/deudor" component={Deudor} />

                    <AppRoute
                      exact
                      path="/confirmed-email"
                      layout={ExternalLayout}
                      component={ConfirmedEmail}
                    />

                    <AppRoute
                      exact
                      path="/payment/success"
                      layout={ExternalLayout}
                      component={SuccessStripe}
                    />

                    <Route
                      exact
                      path="/ingresar"
                      // layout={ExternalLayout}
                      component={Login}
                    />


                    { /** Parte mobile */}
                    <AppRouteMobile
                        exact
                        path="/inventory"
                        layout={ExternalLayout}
                        component={InventoryView}
                      />

                      <AppRouteMobile
                        exact
                        path="/individualItem"
                        layout={ExternalLayout}
                        component={IndividualItemView}
                        
                      />

                      <AppRouteMobile
                        exact
                        path="/stats"
                        layout={ExternalLayout}
                        component={StatsView}
                      />

                      <AppRouteMobile
                        exact
                        path="/warehouses"
                        layout={ExternalLayout}
                        component={WarehousesView}
                        
                      />

                      <AppRouteMobile
                        exact
                        path="/loadItems"
                        layout={ExternalLayout}
                        component={LoadItemsView}
                        
                      />

                      <AppRouteMobile
                        exact
                        path="/unloadItems"
                        layout={ExternalLayout}
                        component={UnloadItemsView}
                        
                      />

                      <AppRouteMobile
                        exact
                        path="/chatIA"
                        layout={ExternalLayout}
                        component={ChatIAView}
                      />

                    <AppRouteMobile
                        exact
                        path="/sales"
                        layout={ExternalLayout}
                        component={SalesView}
                      />

                         <AppRouteMobile
                        exact
                        path="/create-client"
                        layout={ExternalLayout}
                        component={CreateClientView}
                      />

                    <AppRouteMobile
                        exact
                        path="/sale-generate"
                        layout={ExternalLayout}
                        component={SaleGenerateView}
                      />

                      {/** Se termina la parte mobile */}


                    <Route path="/dashboard" exact>
                      <Redirect to="/dashboard/dashboard/init" />
                    </Route>
                    <Route path="/dashboard" component={Dashboard} />
                    <Route exact path="/">
                      <Redirect to="/dashboard/inventario/inventory" />
                      {/* {!localStorage.getItem('credentials') ? (
                    <Redirect to="/ingresar" />
                  ) : (
                    <Redirect to="/dashboard" />
                  )} */}
                      <Redirect to="/ingresar" />
                    </Route>
                    {/* <AppRoute path="*" layout={External} component={NotFound} */}
                  </Switch>
                </BrowserRouter>
              </div>
            </FloatingProvider>
          </TabProvider>
        </SnackBarProvider>
      </ThemeProvider>
    </Provider>
  )
}

export default App

interface AppRouteProps {
  component: React.FC<any> | ConnectedComponent<any, any>
  layout: React.FC
  path: string
  exact?: boolean
  hideTabs?: boolean
}
